import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack';
import { getYears, initPrjGoalData, monthPercent, calcMonthAmountsByPct, autoDistributeMonthGoals, sumMonthPct } from '../../utils/constCodeUtils';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setUserConfig, unloadUserConfig, viewUserConfig } from '../../modules/staticsModule/userConfig';
import * as yup from 'yup';
import { useFormik } from 'formik';
import _ from 'lodash';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';


import * as staticsApi from '../../lib/api/statics';
import YearGoalForm from '../../components/goalsetting/YearGoalForm';
import UserGoalTable from '../../components/goalsetting/UserGoalTable';

// 저장된 목표(ptargetSales)에 pct(배분비율)가 없는 레거시 데이터를 위한 보정 —
// 연간 총액 대비 비율을 역산해서 채워준다(백엔드가 STAT_PCT 이전에 저장된 값).
const fillMissingPct = (monthGoals) => {
    const totalSales = _.sumBy(monthGoals, (g) => Number(g.ptargetSales) || 0);
    return monthGoals.map((g, idx) => {
        if (g.pct !== undefined && g.pct !== null && g.pct !== '') {
            return g;
        }
        const pct = totalSales > 0
            ? Math.round((Number(g.ptargetSales) || 0) / totalSales * 1000) / 10
            : monthPercent[idx];
        return { ...g, pct };
    });
};

const UserGoalListContainer = ({ user }) => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [years, setYears] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    // const [userGoalsData, setUserGoalsData] = useState(null);
    const [userGoalsData, setUserGoalsData] = useState(initPrjGoalData());
    const [totals, setTotals] = useState({ ptargetSales: 0, ptargetSalesProfit: 0 });
    // 2026-10-23 (250423 #5-a): 저장된 목표가 있으면 기본은 읽기전용 — 수정 아이콘을
    // 눌러야 편집 가능. 저장된 값이 없는(신규) 상태는 바로 입력 가능해야 하므로 true.
    const [editable, setEditable] = useState(true);

    const handleChangeYear = (event) => {
        setSelectedYear(event.target.value)
    }

    useEffect(() => {
        const arrYears = getYears(3, 1);
        setYears(arrYears);
    }, []);

    const { userConfig, error, loading } = useSelector(
        ({ staticsModule, loading }) => ({
            userConfig: staticsModule.userConfig.userConfig,
            error: staticsModule.userConfig.error,
            loading: loading['statics/VIEW_USER_CONFIG']
        }),
    );

    useEffect(() => {
        if (user && selectedYear) {
            let searchData = {
                "statYear": selectedYear,
                "usrUuid": user?.usrUuid,
            }
            dispatch(viewUserConfig(searchData))
        }

        return () => {
            dispatch(unloadUserConfig());
        }
    }, [user, selectedYear, dispatch]);

    useEffect(() => {
        if (Array.isArray(userConfig) && userConfig.length > 0) {
            setUserGoalsData(fillMissingPct(userConfig));
            setEditable(false);

            const ptargetSales = _.sumBy(userConfig, 'ptargetSales');
            const ptargetSalesProfit = _.sumBy(userConfig, 'ptargetSalesProfit');

            setTotals((prevState) => ({
                ...prevState,
                ptargetSales, ptargetSalesProfit
            }));


        } else {

            setUserGoalsData(initPrjGoalData());
            setEditable(true);
        }
    }, [userConfig]);

    let initialValues = {
        ptargetSales:
            userConfig && totals.ptargetSales !== null && totals.ptargetSales !== undefined
                ? totals.ptargetSales
                : '0',
        ptargetSalesProfit:
            userConfig && totals.ptargetSalesProfit !== null && totals.ptargetSalesProfit !== undefined
                ? totals.ptargetSalesProfit
                : '0',
    }
    let validationSchema = yup.object({
        ptargetSales: yup.number('숫자만 가능합니다').required('총 목표매출을 입력하세요').positive('양수만 입력가능합니다'),
        ptargetSalesProfit: yup.number('숫자만 가능합니다').required('총 목표매출 이익을 입력하세요').positive('양수만 입력가능합니다'),
    });
    const onSubmitHandler = (values, { setSubmitting }) => {
        const submit = async () => {
            onSave()

        };
        submit();
    };


    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: onSubmitHandler,
    });


    const onSave = async () => {
        // 2026-10-23 (250423 #5-b): 저장 전 월별 배분비율 합계가 정확히 100%인지 검사.
        // 아니면 저장을 막고 안내만 한다(반올림 오차 허용은 자동배분 계산 안에서만
        // 처리되고, 여기 100% 검사는 예외 없이 정확히 적용한다).
        const pctSum = sumMonthPct(userGoalsData);
        if (pctSum !== 100) {
            enqueueSnackbar(`월별 배분 비율 합계가 100%가 아닙니다 (현재 ${pctSum}%). 비율을 맞춘 뒤 저장하세요.`, {
                variant: 'error',
            });
            formik.setSubmitting(false);
            return;
        }

        let dataToSubmit = {
            usrUuid: user.usrUuid,
            year: selectedYear,
            monthGoals: userGoalsData
        }

        try {
            const res = await staticsApi.addStaticsConf(dataToSubmit);
            if (res.data.list) {
                dispatch(setUserConfig(res.data));
                enqueueSnackbar("목표 설정이 저장되었습니다", {
                    variant: 'success',
                });
                formik.setSubmitting(false);
                setEditable(false);
            }
        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
            formik.setSubmitting(false);
        }

    }

    // 자동배분: 기본 비율로 되돌리고(monthPercent), 현재 입력된 연간 총액 기준으로
    // 월별 금액을 다시 계산한다.
    const onAutoDisHandler = (totalSales, totalProfit) => {
        const months = autoDistributeMonthGoals(totalSales, totalProfit);
        setUserGoalsData(months);
    }

    // 연간 총목표매출/총매출이익 입력칸이 바뀔 때마다(저장된 % 비율은 그대로 두고)
    // 월별 금액만 바로 다시 계산한다 — formik.handleChange를 직접 쓰지 않고 이
    // 핸들러를 거치게 해서, 리렌더 타이밍에 따른 값 꼬임 없이 입력 이벤트에서 바로
    // 최신 값으로 계산한다.
    const handleTotalFieldChange = (e) => {
        formik.handleChange(e);
        const { name, value } = e.target;
        const nextSales = name === 'ptargetSales' ? value : formik.values.ptargetSales;
        const nextProfit = name === 'ptargetSalesProfit' ? value : formik.values.ptargetSalesProfit;
        const pctArray = userGoalsData.map((g) => g.pct);
        const recalculated = calcMonthAmountsByPct(nextSales, nextProfit, pctArray);
        const merged = recalculated.map((g, idx) => ({ ...g, pct: pctArray[idx] }));
        setUserGoalsData(merged);
    };

    const onEditClick = () => {
        setEditable(true);
    }

    if (loading) {
        return (
            <Box
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <CircularProgress />
            </Box>
        )
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', px: 1, alignItems: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Box sx={{ mr: 1, minWidth: 120 }}>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="selected-year-label">기준년도</InputLabel>
                            <Select
                                labelId="selected-year-label"
                                id="selected-year"
                                value={selectedYear}
                                label="년도"
                                onChange={handleChangeYear}
                            >
                                {years && years.map((item, index) => (
                                    <MenuItem key={index} value={item}>{item}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Box>

                </Box>
                {(!Array.isArray(userConfig) || userConfig.length === 0) && (
                    <Box sx={{ px: 1 }}>
                        <Typography variant="body2" component="div">해당 사원의 {selectedYear} 년도 설정된 목표값이 없습니다.</Typography>
                    </Box>
                )}
            </Box>
            <Divider sx={{ my: 1 }} />
            <YearGoalForm
                formik={formik}
                onAutoDisHandler={onAutoDisHandler}
                onTotalFieldChange={handleTotalFieldChange}
                editable={editable}
                hasSavedData={Array.isArray(userConfig) && userConfig.length > 0}
                onEditClick={onEditClick}
            />
            <UserGoalTable
                monthGoals={userGoalsData}
                totalSales={formik.values.ptargetSales}
                totalProfit={formik.values.ptargetSalesProfit}
                editable={editable}
                // 편집된 goals 을 부모 상태에 반영
                onChangeGoals={updated => setUserGoalsData(updated)}
            />
        </Box>
    )
}

export default UserGoalListContainer